import actions from "./actions";

const {
    FETCH_EMAIL_SERVER_INVOICES,
    FETCH_EMAIL_SERVER_INVOICE,
    RESET_EMAIL_SERVER_INVOICE
} = actions;

const initState = {
    emailServerInvoices: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    emailServerInvoice: { _id: null }
};

const EmailServerInvoiceReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_EMAIL_SERVER_INVOICES:
            return {
                ...state,
                emailServerInvoices: data
            };

        case RESET_EMAIL_SERVER_INVOICE:
            return {
                ...state,
                emailServerInvoice: initState.emailServerInvoice
            };

        case FETCH_EMAIL_SERVER_INVOICE:
            return {
                ...state,
                emailServerInvoice: data
            };

        default:
            return state;
    }
};

export default EmailServerInvoiceReducer;